import { addLocaleData } from "react-intl";

import * as de from "react-intl/locale-data/de";
import * as en from "react-intl/locale-data/en";
import * as fr from "react-intl/locale-data/fr";

addLocaleData([...en, ...de, ...fr]);

export const localizedMessages = {
  de: require("./messages/de.json"),
  en: require("./messages/en.json"),
  fr: require("./messages/fr.json")
};

export const languages = {
  en: "English",
  de: "Deutsch",
  fr: "Français"
};

const localeKey = "locale";
export const defaultLanguage = Object.getOwnPropertyNames(languages)[0];

class LocaleStore {
  public getLanguage() {
    return localStorage.getItem(localeKey) || defaultLanguage;
  }

  public getMessages() {
    return localizedMessages[this.getLanguage()];
  }

  public setLocale(lang: string) {
    localStorage.setItem(localeKey, lang);
  }

  public getLanguages(): string[] {
    return Object.getOwnPropertyNames(localizedMessages);
  }

  public getLanguageDisplayName(lang: string) {
    return languages[lang];
  }
}

export const localeStore = new LocaleStore();



// WEBPACK FOOTER //
// ./src/i18n/locale-store.ts